"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HashRegistry__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "initialOwner",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [],
        name: "ECDSAInvalidSignature",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "length",
                type: "uint256",
            },
        ],
        name: "ECDSAInvalidSignatureLength",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "s",
                type: "bytes32",
            },
        ],
        name: "ECDSAInvalidSignatureS",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
        ],
        name: "OwnableInvalidOwner",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "OwnableUnauthorizedAccount",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "hashType",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "hashValue",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "hashTimestamp",
                type: "uint256",
            },
        ],
        name: "RegisteredHash",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "hashType",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "hashValue",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "hashTimestamp",
                type: "uint256",
            },
        ],
        name: "SetHash",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "hashType",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "address[]",
                name: "signers",
                type: "address[]",
            },
        ],
        name: "SetSigners",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "hashType",
                type: "bytes32",
            },
        ],
        name: "getHashValue",
        outputs: [
            {
                internalType: "bytes32",
                name: "hashValue",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        name: "hashTypeToSignersHash",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        name: "hashes",
        outputs: [
            {
                internalType: "bytes32",
                name: "value",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "timestamp",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "hashType",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "hashValue",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "hashTimestamp",
                type: "uint256",
            },
            {
                internalType: "bytes[]",
                name: "signatures",
                type: "bytes[]",
            },
        ],
        name: "registerHash",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "hashType",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "hashValue",
                type: "bytes32",
            },
        ],
        name: "setHash",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "hashType",
                type: "bytes32",
            },
            {
                internalType: "address[]",
                name: "signers",
                type: "address[]",
            },
        ],
        name: "setSigners",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "signatureDelegationHashType",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class HashRegistry__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(initialOwner, overrides) {
        return super.getDeployTransaction(initialOwner, overrides || {});
    }
    deploy(initialOwner, overrides) {
        return super.deploy(initialOwner, overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static bytecode = _bytecode;
    static abi = _abi;
    static createInterface() {
        return new ethers_1.Interface(_abi);
    }
    static connect(address, runner) {
        return new ethers_1.Contract(address, _abi, runner);
    }
}
exports.HashRegistry__factory = HashRegistry__factory;
//# sourceMappingURL=HashRegistry__factory.js.map